/* NEXRA PDP — chan "Add to cart" cho tới khi khach chon size (kieu AYBL).

   ⚠️ KHONG bo checked cua radio size. Dawn doc trang thai variant bang
   `Array.from(fieldset.querySelectorAll('input')).find(r => r.checked)?.value`,
   nen bo checked se lam options[size] = undefined -> khong tim ra variant ->
   Dawn xoa gia va doi nut thanh "Unavailable". Cach dung: GIU checked cua Dawn
   (moi thu van chay dung) va chi CHE trang thai da chon bang class
   `nx-size-unpicked`, dong thoi khoa nut. Khach bam size dau tien thi mo.

   ⚠️ Dung `click` chu khong `change`: neu khach bam dung o size ma Dawn da
   checked san thi `change` khong bao gio ban. */
(function () {
  var FS = '.product-form__input--nx-size';
  var LOCKED = 'nx-atc-locked';
  var UNPICKED = 'nx-size-unpicked';
  var picked = false;

  function fieldsets() { return document.querySelectorAll(FS); }
  function buttons() { return document.querySelectorAll('.product-form__submit'); }

  // NEXRA 09/10 (tam ngung ban): o size DANG DUOC CHON co mang data-nx-chan khong (Liquid gan cho bien the nam trong
  // settings.nx_chan_ids). Bien the do hien nhu het hang: nut khoa "Sold out", khong co Notify me.
  // 09/10 (dot 2): moi lan doi mau / size Dawn GIU khoi variant-selects CU trong DOM them 0,5 giay (display none) roi moi go.
  // O size cua khoi cu van con checked => phai bo qua khoi dang an; khong thi dang o bien the tam ngung ma doi sang MAU khac
  // (bien the moi mua duoc) la nut bi khoa lai "Sold out" va ket o do.
  function dangChan() {
    var ds = document.querySelectorAll(FS + ' input[data-nx-chan]:checked');
    for (var i = 0; i < ds.length; i++) {
      var vs = ds[i].closest('variant-selects');
      if (!vs || vs.style.display !== 'none') return true;
    }
    return false;
  }

  function apply() {
    var fs = fieldsets();
    if (!fs.length) return;
    var chan = dangChan();
    var vsx = window.variantStrings || {};
    fs.forEach(function (f) {
      f.classList.toggle(UNPICKED, !picked);
      // Nhan Sold out canh gia cua bien the tam ngung ban chi hien SAU khi khach chon size (CSS trong snippets/nx-chan.liquid).
      var c = f.closest('.product__info-container');
      if (c) c.classList.toggle('nx-size-picked', picked);
    });
    buttons().forEach(function (b) {
      // San pham het hang / khong ban thi de nguyen Dawn xu ly
      if (b.hasAttribute('data-nx-soldout')) return;
      var span = b.querySelector('span:not(.visually-hidden)') || b.querySelector('span') || b;
      if (picked) {
        var mo = b.classList.contains(LOCKED);
        if (mo) {
          b.classList.remove(LOCKED);
          b.removeAttribute('aria-disabled');
        }
        if (chan) {
          // Khach bam dung o size da duoc chon san (Dawn khong chay lai) => tu khoa nut nhu het hang.
          if (!b.disabled) b.disabled = true;
          var so = vsx.soldOut || 'Sold out';
          if (span.textContent.trim() !== so) span.textContent = so;
        } else if (mo && b.dataset.nxLabel) {
          span.textContent = b.dataset.nxLabel;
        }
      } else {
        if (b.disabled) {
          if (chan) {
            // Bien the dang giu (chua ai chon size) nam trong danh sach tam ngung ban: van la "Select a size",
            // khong phai ca san pham het hang. Chon dung size do thi nhanh picked o tren khoa lai.
            b.disabled = false;
            b.dataset.nxLabel = vsx.addToCart || 'Add to cart';
          } else if (!b.classList.contains(LOCKED)) {
            b.dataset.nxNative = '1'; // Dawn tu khoa (sold out) -> dung nhung vao
            return;
          }
        }
        if (!b.dataset.nxLabel) b.dataset.nxLabel = span.textContent.trim();
        // classList.add LUON sinh mutation ke ca khi class da co (chuan DOM) -> phai kiem truoc.
        if (!b.classList.contains(LOCKED)) b.classList.add(LOCKED);
        // ⚠️ KHONG dat b.disabled: nut disabled khong nhan focus va khong ban
        // click, nen khong the day khach toi o size. Dung aria-disabled + chan
        // click o pha capture — vua giu a11y vua xu ly duoc.
        // NEXRA 29/09: CHI ghi khi khac. Ghi de cung gia tri van sinh mutation -> observer ben duoi
        // chay lai apply() -> ghi tiep -> VONG LAP MOI KHUNG HINH (do that: 100 lan/giay tren PDP).
        if (b.getAttribute('aria-disabled') !== 'true') b.setAttribute('aria-disabled', 'true');
        if (span.textContent !== 'Select a size') span.textContent = 'Select a size';
      }
    });
  }

  // "More" mo/dong hang thumbnail thua. Nho trang thai theo ca trang vi Dawn
  // render lai variant-selects moi lan doi mau -> class is-collapsed quay ve.
  var expanded = false;
  var daTuMo = false;
  // O mau dang chon co nam NGOAI hang dau khong (hang dau = --nx-opt-cols o dau tien).
  // Can tu 24/09: vision-shorts len 11 mau, 5 mau moi roi xuong hang 2 nen vao trang bang
  // ?variant= (Quick View, the collection, email Klaviyo) thi KHONG thay o nao sang.
  function chonNgoaiHangDau(v) {
    var lbl = [].slice.call(v.querySelectorAll('label'));
    if (!lbl.length) return false;
    var cols = parseInt(getComputedStyle(v).getPropertyValue('--nx-opt-cols'), 10);
    if (!cols || cols < 1) return false;
    for (var i = 0; i < lbl.length; i++) {
      var id = lbl[i].getAttribute('for');
      var inp = id ? v.querySelector('#' + (window.CSS && CSS.escape ? CSS.escape(id) : id)) : null;
      if (inp && inp.checked) return i >= cols;
    }
    return false;
  }
  function applyMore() {
    if (!expanded && !daTuMo) {
      // Chi tu mo MOT LAN (luc tai trang). Sau do khach dong lai thi ton trong.
      document.querySelectorAll('.nx-opt-values').forEach(function (v) {
        if (v.parentElement.querySelector('.nx-opt-more') && chonNgoaiHangDau(v)) expanded = true;
      });
      if (expanded) daTuMo = true;
    }
    document.querySelectorAll('.nx-opt-values').forEach(function (v) {
      if (!v.parentElement.querySelector('.nx-opt-more')) return;
      v.classList.toggle('is-collapsed', !expanded);
    });
    document.querySelectorAll('.nx-opt-more').forEach(function (b) {
      // NEXRA 29/09: chi ghi khi khac (xem ghi chu trong apply()).
      var ae = expanded ? 'true' : 'false';
      if (b.getAttribute('aria-expanded') !== ae) b.setAttribute('aria-expanded', ae);
      var t = b.querySelector('.nx-opt-more__txt');
      var tt = expanded ? 'Less' : 'More';
      if (t && t.textContent !== tt) t.textContent = tt;
    });
  }

  // Bam nut khi chua chon size: chan them vao gio, cuon toi va nhay o size.
  document.addEventListener('click', function (e) {
    var lockedBtn = e.target && e.target.closest && e.target.closest('.' + LOCKED);
    if (lockedBtn) {
      e.preventDefault();
      e.stopPropagation();
      var f = document.querySelector(FS);
      if (f) {
        f.scrollIntoView({ block: 'center', behavior: 'smooth' });
        f.classList.remove('nx-size-pulse');
        void f.offsetWidth;
        f.classList.add('nx-size-pulse');
      }
      return;
    }
    var more = e.target && e.target.closest && e.target.closest('.nx-opt-more');
    if (more) {
      e.preventDefault();
      expanded = !expanded;
      applyMore();
      return;
    }
    if (picked) return;
    var t = e.target;
    if (!t || !t.closest) return;
    if (t.closest(FS + ' label') || t.closest(FS + ' input')) {
      picked = true;
      // de Dawn xu ly xong roi moi mo nut
      setTimeout(apply, 0);
      setTimeout(apply, 250);
    }
  }, true);

  /* ---------- Size chart modal ---------- */
  function scEl(id) { return document.getElementById(id || 'nx-size-chart'); }
  function scOpen(on, id) {
    var m = scEl(id);
    if (!m) return;
    if (on) {
      m.removeAttribute('hidden');
      void m.offsetWidth;
      m.classList.add('is-open');
      document.documentElement.classList.add('nx-qadd-lock');
      // Focus vao panel chu khong vao nut X: goi .focus() bang JS lam trinh duyet
      // coi la focus-visible -> vong focus den dam quanh nut X ngay khi vua mo.
      var p = m.querySelector('.nx-sc__panel');
      if (p) p.focus({ preventScroll: true });
    } else {
      m.classList.remove('is-open');
      // ⚠️ Chi go khoa cuon khi KHONG con lop phu nao khac dang mo. Size chart
      // mo tu trong Quick View drawer: go bua la trang chay nen duoi drawer.
      var qv = document.querySelector('.nx-qv-drawer.is-open');
      if (!qv) document.documentElement.classList.remove('nx-qadd-lock');
      setTimeout(function () {
        if (m && !m.classList.contains('is-open')) m.setAttribute('hidden', '');
      }, 260);
    }
  }
  function scUnit(u, m) {
    if (!m) return;
    m.querySelectorAll('[data-nx-u]').forEach(function (s) {
      if (s.dataset.nxU === u) s.removeAttribute('hidden');
      else s.setAttribute('hidden', '');
    });
    m.querySelectorAll('.nx-sc__unit').forEach(function (b) {
      b.classList.toggle('is-active', b.dataset.nxUnit === u);
      b.setAttribute('aria-pressed', b.dataset.nxUnit === u ? 'true' : 'false');
    });
  }
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var open = t.closest('.nx-size-chart');
    if (open) {
      e.preventDefault();
      e.stopPropagation();
      scOpen(true, open.getAttribute('aria-controls'));
      return;
    }
    var close = t.closest('[data-nx-sc-close]');
    if (close) {
      e.preventDefault();
      e.stopPropagation();
      var box = close.closest('.nx-sc');
      scOpen(false, box ? box.id : null);
      return;
    }
    var u = t.closest('.nx-sc__unit');
    if (u) { e.preventDefault(); scUnit(u.dataset.nxUnit, u.closest('.nx-sc')); }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    // Esc dong size chart TRUOC (no nam tren drawer), khong dong ca hai cung luc.
    var open = document.querySelector('.nx-sc.is-open');
    if (open) { e.stopPropagation(); scOpen(false, open.id); }
  }, true);

  // NEXRA 29/09: dong ho sale ([data-nx-clock]) doi chu MOI GIAY ngay trong khoi info. Neu khong bo qua,
  // moi giay observer nay lai chay lai toan bo (doc layout) => luong chinh ban lien tuc, mo anh/cuon bi giat.
  function chiDongHo(ms) {
    for (var i = 0; i < ms.length; i++) {
      var n = ms[i].target; if (n && n.nodeType !== 1) n = n.parentElement;
      if (!n || !n.closest || !n.closest('[data-nx-clock]')) return false;
    }
    return true;
  }
  function boot() {
    apply();
    applyMore();
    // Dawn render lai ca khoi thong tin khi doi mau -> class va nhan nut bi mat.
    var host = document.querySelector('.product__info-container') || document.body;
    var pending = false;
    new MutationObserver(function (ms) {
      if (pending || chiDongHo(ms)) return;
      pending = true;
      requestAnimationFrame(function () { pending = false; apply(); applyMore(); });
    }).observe(host, { childList: true, subtree: true, attributes: true, attributeFilter: ['disabled', 'class'] });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();

/* NEXRA 30/09: bam badge sao + "N reviews" duoi ten san pham -> cuon muot toi khu review #judgeme_product_reviews.

   Judge.me KHONG gan click nao cho badge nay (badge lay tu metafield judgeme.badge, khong co handler; trong
   jdgmSettings cung khong co setting nao ve viec bam badge). Judge.me chi co san phan ban phim: delegate keyup
   tren document, tha Enter/Space tren .jdgm-prev-badge thi goi .click().
   O day tu xu ly: click (chuot/cham) + keydown Enter/Space (de Space khong cuon trang di 1 man), roi bo qua cu
   click gia Judge.me ban ra ngay sau khi tha phim (click do co e.detail === 0).

   Khoang tru o dinh = chieu cao header sticky DO LUC CHAY (desktop 61 · mobile 53, do 30/09), cong them thanh mua
   dinh .nx-sb neu no nam o nua TREN man (hien tai no nam o DAY nen khong tinh).
   Cuon xong kiem lai 1 lan va chinh neu anh tai muon phia tren lam lech dich. Khach tu cuon/cham trong luc do thi thoi.
   09/10: viec "doi cuon xong" dem bang khung hinh (requestAnimationFrame), xem ghi chu trong cuon(). */
(function () {
  var BADGE = '.nx-jdgm-pdp-badge .jdgm-prev-badge';
  var boQuaDen = 0;
  var dangCho = null;

  function dich() {
    var el = document.getElementById('judgeme_product_reviews');
    return el && el.offsetHeight > 0 ? el : null;
  }

  function khoangTren() {
    var tong = 0;
    var h = document.querySelector('.section-header');
    if (h) {
      var cs = getComputedStyle(h);
      var sh = h.querySelector('sticky-header');
      var an = sh && sh.getAttribute('data-sticky-type') === 'on-scroll-up';
      if ((cs.position === 'sticky' || cs.position === 'fixed') && !an) tong += h.getBoundingClientRect().height;
    }
    var sb = document.querySelector('.nx-sb.is-open');
    if (sb) {
      var r = sb.getBoundingClientRect();
      if (r.height > 0 && r.top < window.innerHeight / 2) tong += r.height;
    }
    return tong;
  }

  function huyCho() {
    if (!dangCho) return;
    if (dangCho.r) window.cancelAnimationFrame(dangCho.r);
    ['wheel', 'touchstart', 'mousedown', 'keydown'].forEach(function (ev) { window.removeEventListener(ev, huyCho, true); });
    dangCho = null;
  }

  function cuon(el) {
    huyCho();
    var muot = !(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
    var y = Math.max(0, Math.round(el.getBoundingClientRect().top + window.pageYOffset - khoangTren()));
    window.scrollTo({ top: y, behavior: muot ? 'smooth' : 'auto' });

    /* NEXRA 09/10 (cuon badge): doi cuon DUNG HAN roi moi chinh 1 lan neu lech > 2px.
       Dem "dung yen" bang requestAnimationFrame, KHONG bang setTimeout. Ban 30/09 dem 3 nhip setTimeout 100ms:
       tab khong ve khung hinh (bi che / chuyen tab / tat man hinh) thi cuon muot DUNG GIUA CHUNG ma dong ho van chay,
       ma tuong da cuon xong va chinh ngay luc cuon muot con dang do => trinh duyet cong don => roi xuong DAY TRANG.
       requestAnimationFrame chi chay khi co khung hinh: khong co khung hinh thi khong dem, cuon muot tu chay not khi tab
       hien lai roi moi kiem. Moi khung chi cong toi da 50ms (khung dau sau khi tab hien lai khong duoc tinh ca quang da dung).
       Dung yen du 300ms cua khung hinh that moi chinh; qua 8 giay khung hinh that ma chua dung yen thi thoi, khong chinh. */
    dangCho = { r: 0, truoc: window.pageYOffset, yen: 0, tong: 0, t: 0 };
    ['wheel', 'touchstart', 'mousedown', 'keydown'].forEach(function (ev) { window.addEventListener(ev, huyCho, { capture: true, passive: true }); });
    (function cho() {
      if (!dangCho) return;
      dangCho.r = window.requestAnimationFrame(function (now) {
        var c = dangCho;
        if (!c) return;
        var dt = c.t ? Math.min(50, Math.max(0, now - c.t)) : 0;
        c.t = now;
        var sy = window.pageYOffset;
        if (Math.abs(sy - c.truoc) < 1) c.yen += dt; else { c.yen = 0; c.truoc = sy; }
        c.tong += dt;
        if (c.yen >= 300) {
          var lech = Math.round(el.getBoundingClientRect().top - khoangTren());
          huyCho();
          if (Math.abs(lech) > 2) window.scrollTo({ top: Math.max(0, window.pageYOffset + lech), behavior: 'auto' });
          return;
        }
        if (c.tong > 8000) { huyCho(); return; }
        cho();
      });
    })();
  }

  document.addEventListener('click', function (e) {
    var b = e.target && e.target.closest ? e.target.closest(BADGE) : null;
    if (!b) return;
    if (e.detail === 0 && Date.now() < boQuaDen) return;
    var el = dich();
    if (!el) return;
    e.preventDefault();
    cuon(el);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ' && e.key !== 'Spacebar') return;
    var b = e.target && e.target.closest ? e.target.closest(BADGE) : null;
    if (!b) return;
    var el = dich();
    if (!el) return;
    e.preventDefault();
    if (e.repeat) return;
    boQuaDen = Date.now() + 1000;
    cuon(el);
  });
})();
